"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _reactSpinkit = _interopRequireDefault(require("react-spinkit"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var defaultSpinner = /*#__PURE__*/_react["default"].createElement(_reactSpinkit["default"], {
  fadeIn: "none",
  name: "circle",
  color: "#a9adc0",
  style: {
    width: 30,
    height: 30
  }
});

var LoadingScreen = function LoadingScreen(_ref) {
  var _ref$spinner = _ref.spinner,
      spinner = _ref$spinner === void 0 ? defaultSpinner : _ref$spinner;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "loadingScreen ".concat( /*#__PURE__*/(0, _emotion.css)("position:absolute;left:0px;right:0px;top:0px;bottom:0px;display:flex;justify-content:center;align-items:center;"))
  }, spinner);
};

var _default = LoadingScreen;
exports["default"] = _default;